export const UDPATE_FROM_HASH = 'EULA_UPDATE_EULA_FROM_HASH'
export const SHOW_EULA = 'EULA_SHOW_EULA'
export const EULA_INITIATED = 'EULA_EULA_INITIATED'
export const EULA_PROMPTED = 'EULA_EULA_PROMPTED'
export const EULA_NOT_OK = 'EULA_EULA_NOT_OK'
export const EULA_DECLINED = 'EULA_EULA_DECLINED'
export const EULA_ACCEPTED = 'EULA_EULA_ACCEPTED'



// WEBPACK FOOTER //
// ./src/features/Eula/data/constants.js